import { render } from "./AgeRangeSection.vue?vue&type=template&id=0c63ad0f"
import script from "./AgeRangeSection.vue?vue&type=script&lang=js"
export * from "./AgeRangeSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__